import { FormControl } from '@angular/forms';

//This validator works for DNI and NIE
export function validateDni(d: FormControl) {
    if (d.value !== '') {
        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^\d{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        var nieRexp = /^[XYZxyz]\d{7}[A-Za-z]$/;
        var letter = d.value.substr(-1);
        var str = d.value.toUpperCase();

        if (!nifRexp.test(d.value) && !nieRexp.test(d.value)) return { validatedni: true };

        var nie = str.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');

        var num = parseInt(nie.substring(0, nie.length - 1)) % 23;

        if (validChars[num] != letter) return { validatedni: true };

        return null;
    }
    return { validatedni: true };
}

export function validateExpirationNif(fechaCaducidad: FormControl) {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fechaMaximaPermitida = new Date(hoy);
    fechaMaximaPermitida.setFullYear(hoy.getFullYear() + 10);
    fechaMaximaPermitida.setHours(0, 0, 0, 0);
    const valido = ((fechaCaducidad.value <= fechaMaximaPermitida) && (fechaCaducidad.value >= hoy));
    if (!valido)
        return {validateExpirationNif : true};
    return null;
  }
